<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.last_name }"
      )
        .form-elem__title Фамилия
        .form-elem__body
          input.input.input_full.input_capitalize(
            v-model="localLastName"
            v-on:keyup="keymonitor"
            maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.first_name }"
      )
        .form-elem__title Имя
        .form-elem__body
          input.input.input_full.input_capitalize(
            v-model="localFirstName"
            v-on:keyup="keymonitor"
            maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.fathers_name }"
      )
        .form-elem__title Отчество
        .form-elem__body
          input.input.input_full.input_capitalize(
            v-model="localFathersName"
            v-on:keyup="keymonitor"
            maxlength="50"
          )
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.gender }"
      )
        .form-elem__title Пол
        .form-elem__body
          simple-select-form(
            :list-data="genderListData"
            :default-value="localGender"
            :enable-default-value-class="true"
            @onChangeDefaultValue="changeGenderValue"
          )
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.date_of_birth }"
      )
        .form-elem__title Дата рождения
        .form-elem__body
          date-picker(
            placeholder="дд.мм.гггг"
            v-model="localDateOfBirth"
            format="DD.MM.YYYY"
            lang="ru"
            input-class="input input_full"
            @change="onChangeDate($event)"
            :clearable="false"
            :editable="true"
            :not-after="new Date()"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.place_of_birth }"
      )
        .form-elem__title Место рождения
        .form-elem__body
          custom-input(
            full
            :suggest="localPlaceOfBirth"
            @onChangeInput="onChangeAddress"
          )
</template>
<script>
import SimpleSelectForm from "@/components/simpleSelectForm/SimpleSelectForm.vue";
import CustomInput from "@/components/customInput/CustomInput";
import DatePicker from "vue2-datepicker";

export default {
  name: "FormParentInfo",
  components: {
    SimpleSelectForm,
    DatePicker,
    CustomInput
  },
  props: {
    gender: {
      type: [Boolean, Object, String],
      default: null
    },
    lastName: {
      type: String,
      default: ""
    },
    firstName: {
      type: String,
      default: ""
    },
    fathersName: {
      type: String,
      default: ""
    },
    dateOfBirth: {
      type: [String, Object],
      default: null
    },
    placeOfBirth: {
      type: [String, Object],
      default: null
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      genderListData: [
        {
          text: "Мужской",
          value: true
        },
        {
          text: "Женский",
          value: false
        }
      ]
    };
  },
  computed: {
    localLastName: {
      get() {
        return this.lastName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "last_name"]);
      }
    },
    localFirstName: {
      get() {
        return this.firstName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "first_name"]);
      }
    },
    localFathersName: {
      get() {
        return this.fathersName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "fathers_name"]);
      }
    },
    localGender: {
      get() {
        if (this.gender === null) {
          return {
            text: "Пол",
            value: null
          };
        }
        return this.genderListData.find(el => el.value === this.gender);
      },
      set() {}
    },
    localDateOfBirth: {
      get() {
        if (!this.dateOfBirth) {
          return "";
        }
        return this.dateOfBirth;
      },
      set() {}
    },
    localPlaceOfBirth: {
      get() {
        return this.placeOfBirth;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "place_of_birth"]);
      }
    }
  },
  methods: {
    onChangeAddress(data) {
      this.$emit("onChangeValue", [data[0], "place_of_birth"]);
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.$emit("onChangeValue", [_date, "date_of_birth"]);
    },
    changeGenderValue(data) {
      this.$emit("onChangeValue", [data.value, "gender"]);
    }
  },
  mounted() {}
};
</script>
